import CONSTANT from './constant.js'

/**
 *
 * @param {string[]} fingerprint ex: ['chrome-extension', 'dhdgffkkebhmkfjojejmpbldmpobfkfo', 'netfunnel-bypass-tools.user.js']
 * @returns {string|null} null 만약 변경 필요 없으면
 */
export default function getLogLevelByPriority(fingerprint = []) {
  if (!Array.isArray(fingerprint)) return null

  if (fingerprint.includes(CONSTANT.ISSUE_GROUP.TAMPERMONKEY)) { return 'debug' }
  if (fingerprint.includes(CONSTANT.ISSUE_GROUP.CHROME_EXTENSION)) { return 'info' }
  return null
}
